<!-- src/components/common/BottomGuidePanel.vue -->
<template>
  <transition name="slide-up">
    <div v-if="isOpen" class="fixed bottom-0 left-0 right-0 shadow-[0_-20px_50px_-12px_rgba(15,23,42,0.3)] z-[100] flex flex-col h-[60vh] sm:h-[450px]">
      
      <!-- Panel Header (Midnight Blue Protocol) -->
      <div class="flex items-center justify-between px-8 py-6 bg-[#0A1630] border-b-4 border-[#20FCF1] shrink-0 rounded-t-[40px] relative overflow-hidden">
        <!-- Subtle background glow -->
        <div class="absolute -left-10 -top-10 w-40 h-40 bg-[#20FCF1] opacity-5 blur-[50px] rounded-full"></div>
        
        <div class="flex items-center gap-4 relative z-10">
          <!-- Premium Shield Icon -->
          <div class="relative w-10 h-10 flex items-center justify-center">
            <svg class="absolute inset-0 w-full h-full text-[#20FCF1] drop-shadow-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L3 7V12C3 17.5 7.1 21.6 12 23C16.9 21.6 21 17.5 21 12V7L12 2Z" fill="currentColor" fill-opacity="0.1" stroke="currentColor" stroke-width="2"/>
            </svg>
            <BookOpenIcon class="h-5 w-5 text-[#20FCF1]" />
          </div>
          
          <div>
            <h3 class="text-xl font-black text-white uppercase tracking-tight">
              {{ title }}
            </h3>
            <p class="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em] mt-0.5">Protocol Assistance & System Guide</p>
          </div>
        </div>

        <div class="flex items-center relative z-10">
          <button 
            @click="$emit('close')" 
            class="bg-white/5 border border-white/10 text-white hover:bg-[#20FCF1] hover:text-[#0A1630] p-2.5 rounded-2xl transition-all duration-300 group shadow-xl"
          >
            <span class="sr-only">Dismiss</span>
            <XMarkIcon class="h-6 w-6 transition-transform group-hover:rotate-90" />
          </button>
        </div>
      </div>

      <!-- Panel Content (Light Mint Background Protocol) -->
      <div class="flex-grow overflow-y-auto p-10 bg-[#EBFDF8]">
        <div class="max-w-7xl mx-auto h-full">
          <slot></slot>
          
          <!-- Explicit footer for mobile dismissal -->
          <div class="mt-12 pt-8 border-t border-[#20FCF1]/10 text-center sm:hidden">
            <button @click="$emit('close')" class="text-[10px] font-black text-slate-400 uppercase tracking-widest hover:text-[#0A1630] transition-colors">
              Tap to Dismiss Guide
            </button>
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script setup>
import { BookOpenIcon, XMarkIcon } from '@heroicons/vue/24/outline';

defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: 'Protocol Guide'
  }
});

defineEmits(['close']);
</script>

<style scoped>
/* High-End Slide Up Animation */
.slide-up-enter-active {
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}
.slide-up-leave-active {
  transition: all 0.4s cubic-bezier(0.7, 0, 0.84, 0);
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0.5;
}

/* Scrollbar styling for internal content */
div::-webkit-scrollbar {
  width: 6px;
}
div::-webkit-scrollbar-track {
  background: #EBFDF8;
}
div::-webkit-scrollbar-thumb {
  background: #20FCF1;
  border-radius: 10px;
}
</style>